<div class="tab-button">
  <ion-note color="light">{{ name | translate }} </ion-note>
</div>
